import { render, staticRenderFns } from "./TgeKeys.vue?vue&type=template&id=73bb8dd0&"
import script from "./TgeKeys.vue?vue&type=script&lang=js&"
export * from "./TgeKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73bb8dd0')) {
      api.createRecord('73bb8dd0', component.options)
    } else {
      api.reload('73bb8dd0', component.options)
    }
    module.hot.accept("./TgeKeys.vue?vue&type=template&id=73bb8dd0&", function () {
      api.rerender('73bb8dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamCarriers/components/TgeKeys.vue"
export default component.exports